module.exports = function() {
  const { pathname, search } = window.location;

  return (
    pathname.includes('/browse') &&
    search.includes('category=things-to-do') &&
    !search.includes('category2') &&
    !search.includes('category3')
  );
};
